import React, { memo } from "react";
import { useHistory } from 'react-router-dom';
import ReactDOM from "react-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { Typography } from "@mui/material";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="outlined" {...props} />;
});

/**
 * @param {
 * showNotify // 'show' || 'hide'
 * setShowNotify // function to hide Notify
 * notifyPrimaryText // Primary text to display
 * notifyDescription // Sub text to display
 * notifyType // 'error' || 'success' || 'warning' || 'info'
 * notifyRedirectLink // path to route user on click, this will be rendered along with the sub text, for currently use in reports
 * } 
 * @returns 
 */
const Notify = memo(function Notify(props) {
    const history = useHistory();
    const { notifyType, notifyPrimaryText,showNotify } = props;
    function handleCloseToast() {
        setTimeout(() => {
            props.setShowNotify('hide');
            if (props) {
                props.setNotifyDescription("");
                if (props.setNotifyPrimaryText) {
                    props.setNotifyPrimaryText("");
                }
            }
        }, 2000);
    }

    function handleRedirectToReport() {
        history.push(props.notifyRedirectLink);
        setTimeout(() => props.setShowNotify('hide'), 2000)
    }

    //background colors 
    const backgroundColorMap = {
        success: "#E3F7FF",
        warning: "#FFF8E1",
        info: "#EEFAFF",
        error: "#FFECEC",
    };

    const backgroundColor = backgroundColorMap[notifyType] || "#FFECEC";
    const iconMap = {
        success: { component: ThumbUpOffAltIcon, style: { height: 36, width: 36, color: "#25B40D", position: "absolute" } },
        warning: { component: WarningAmberIcon, style: { height: 30, width: 30, color: "#FFA500", position: "absolute", marginTop: -3 } },
        info: { component: InfoOutlinedIcon, style: { height: 30, width: 30, color: "#0077B7", position: "absolute", marginTop: -3 } },
        error: { component: HighlightOffRoundedIcon, style: { height: 24, width: 24, color: "#DF3C3C", position: "absolute", marginTop: -5 } },
    };

    const renderIcon = () => {
        const { component: Icon, style } = iconMap[notifyType] || iconMap.error;
        return <Icon style={style} />;
    };

    //Extract values before returning JSX
    const isSuccess = notifyType === "success";
    const marginTop = !notifyPrimaryText && isSuccess ? "20px" : "0px";
    const marginLeft = isSuccess ? "50px" : "35px";

    const notifyTitle =
        notifyPrimaryText ??
        (
            notifyType === "success" ? "Success" :
                notifyType === "warning" ? "Warning" :
                    notifyType === "info" ? "Info" : "Error"
        );


    return ReactDOM.createPortal(
            <Snackbar
                open={showNotify === "show"}
                autoHideDuration={7000}
                onClose={()=>handleCloseToast()}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                style={{
                    backgroundColor,
                    height: "auto !important",
                    width: "596px",
                    borderRadius: "8px",
                    boxShadow: "none",
                }}>
                <Alert
                    severity=""
                    sx={{
                        width: "100%",
                        boxShadow: "none",
                    }}
                    style={{
                        backgroundColor,
                        height: "auto",
                        width: "596px",
                        borderRadius: "8px",
                        boxShadow: "none",
                    }}>
                    <div style={{ marginTop: "15px" }}>
                        {renderIcon()}
                        <div
                            style={{marginTop}}>
                            <Typography
                                variant="h5"
                                style={{
                                    marginLeft,
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    lineHeight: "16.94px",
                                    color: "#212121",
                                }}>
                                {notifyTitle}
                            </Typography>
                        </div>

                        <Typography
                            variant="body1"
                            style={{
                                marginLeft:
                                    notifyType === "success"
                                        ? "50px"
                                        : "35px",
                                fontSize: "14px",
                                marginTop: "14px",
                                color: "#909597",
                            }}>
                            {props.notifyDescription}
                            {props.notifyRedirectLink && (
                                <>&nbsp;<span onClick={()=>handleRedirectToReport()} style={{ cursor: 'pointer', color: 'blue' }}>Go to report.</span></>
                            )}
                        </Typography>
                    </div>
                </Alert>
            </Snackbar>,
            document.body 
    );
});

export default Notify;
